module.exports = __webpack_public_path__ + "assets/img/game_bg.0bbbed4e.png";